// @flow
import * as React from 'react';
import { Field } from 'redux-form';

import Input from './TextField';

type Props = {
	name: string,
	inputRef?: { current: ?HTMLInputElement } | null,
	className?: string,
	placeholder?: string,
	eventListeners?: { [id: string]: Function },
	isTextarea?: boolean,
	textareaType?: number,
	inlineType?: boolean,
	disabled?: boolean,
	clearValue?: boolean,
	maxWordsLength?: number,
	numberField?: boolean,
	minNumber?: number,
	maxNumber?: number,
	isLtr?: boolean,
};

export default class Text extends React.PureComponent<Props> {
	static defaultProps = {
		inputRef: null,
		className: '',
		placeholder: '',
		eventListeners: {},
		isTextarea: false,
		textareaType: 1,
		inlineType: false,
		disabled: false,
		clearValue: false,
		maxWordsLength: 1500,
		numberField: false,
		minNumber: 0,
		maxNumber: 120,
		isLtr: false,
	};

	render() {
		const {
			name,
			className,
			placeholder,
			inputRef,
			eventListeners,
			isTextarea,
			textareaType,
			inlineType,
			disabled,
			clearValue,
			maxWordsLength,
			numberField,
			minNumber,
			maxNumber,
			isLtr,
		} = this.props;
		const InputComponent = props => (
			<Input
				{...props}
				placeholder={placeholder}
				className={className}
				inputRef={inputRef}
				eventListeners={eventListeners}
				isTextarea={isTextarea}
				textareaType={textareaType}
				inlineType={inlineType}
				disabled={disabled}
				clearValue={clearValue}
				maxWordsLength={maxWordsLength}
				numberField={numberField}
				minNumber={minNumber}
				maxNumber={maxNumber}
				isLtr={isLtr}
			/>
		);

		return <Field {...this.props} name={name} component={InputComponent} />;
	}
}
